/*!
 * DHL User Interface Library - https://docs.uilibrary.dhl
 *   9fbef606107a605d69c0edbcd8029e5d
 */
import { S as Sizes, O as Orientation, c as Steps, V as Variants } from './constants-c94b83bd.js';

const DHL_INDICATOR_STEP_SIZES = {
    SM: Sizes.SM,
    MD: Sizes.MD,
};
const DHL_INDICATOR_STEP_TYPES = {
    HORIZONTAL: Orientation.horizontal,
    VERTICAL: Orientation.vertical,
};
const DHL_INDICATOR_STEP_STEPS = {
    CURRENT: Steps.current,
    FINISHED: Steps.finished,
    PARTIAL: Steps.partial,
    UPCOMING: Steps.upcoming,
};
const DHL_INDICATOR_STEP_CONNECTOR_TYPES = {
    EMPTY: Variants.empty,
    LINE: Variants.line,
    ARROW: Variants.arrow,
};
const DHL_INDICATOR_STEP = {
    SIZE: DHL_INDICATOR_STEP_SIZES,
    TYPE: DHL_INDICATOR_STEP_TYPES,
    STEP: DHL_INDICATOR_STEP_STEPS,
    CONNECTOR_TYPE: DHL_INDICATOR_STEP_CONNECTOR_TYPES,
};

export { DHL_INDICATOR_STEP as D };

//# sourceMappingURL=constants-35b5fb29.js.map